import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { Auth } from 'aws-amplify';

@Injectable({
  providedIn: 'root'
})
export class AutoLogoutService {

  private timeoutDuration = 1 * 60 * 60 * 1000;
  private timeoutId: any;

  constructor(
    private router: Router,
    private ngZone: NgZone
  ) {}

  init(): void{
    this.trackActivity();
    this.startTimer();
  }

  startTimer(): void {
    this.ngZone.runOutsideAngular(() => {
      this.timeoutId = setTimeout(() => {
        this.ngZone.run(() => {
          this.logout();
        });
      }, this.timeoutDuration);
    });
  }

  resetTimer(): void {
    clearTimeout(this.timeoutId);
    this.startTimer();
  }

  logout(): void {
    Auth.signOut({ global: true })
      .then(data => {
        this.router.navigate(['/landing-page']);
      })
      .catch(err => {
        var keys = Object.keys(localStorage);
        for (let i = 0; i < keys.length; i++) {
          localStorage.removeItem(keys[i]);
        }
        this.router.navigate(['/landing-page']);
      });
  }

  trackActivity(): void {
    window.addEventListener('mousemove', () => this.resetTimer());
    window.addEventListener('keydown', () => this.resetTimer());
    window.addEventListener('click', () => this.resetTimer());
    window.addEventListener('scroll', () => this.resetTimer());
  }
}
